namespace TabAurous.Inventory {
    export namespace MaterialReceiptSelectItemsService {
        export const baseUrl = 'Purchase/MaterialReceiptSelectItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<MaterialReceiptItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Purchase/MaterialReceiptSelectItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>MaterialReceiptSelectItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
